import { mapState } from 'vuex'

import './style.scss'

import Logo from 'components/Logo'
import MetaNav from 'components/MetaNav'
import MainNav from 'components/MainNav'
import MobileNav from 'components/MobileNav'

export default {
  name: 'Header',
  computed: mapState({
    open: state => state.ui.menuOpen,
    modalOpen: state => state.ui.modalOpen
  }),
  render (h) {
    return (
      <header class={'Header' + (this.modalOpen ? ' is-hidden' : '')}>
        <div class='Header__content Header__content--mobile'>
          <MobileNav />
        </div>
        <div class='Header__content Header__content--meta'
          hidden={this.open ? 'hidden' : null}
        >
          <MetaNav location={'meta'} />
        </div>
        <div class='Header__content Header__content--main'
          hidden={this.open ? 'hidden' : null}
        >
          <div class='Header__logo'>
            <Logo />
          </div>
          <div class='Header__nav'>
            <MainNav />
          </div>
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Header/index.js